* {
  @include text-main;
  box-sizing: border-box;
  color: var(--color-dark-grey);
}

input {
  font-size: var( --font-size-xxs);
  background-color: var(--color-white);
  border: 1px solid var(--color-grey);
  border-radius: 5px;
  box-shadow: none;
  color: var(--font-color-main);
  line-height: 40px;
  height: 40px;
  padding: 0 15px;
  text-shadow: none;
  outline: none;
  width: 100%;
}

.container {
  width: 100%;

  > * {
    width: 100%;
  }

  .search {
    display: flex;
    flex-direction: row;
    flex: auto;
    gap: 2rem;

    .input {
      width: 100%;
      position: relative;

      a {
        color: var(--color-darker-grey);
        font-weight: 700;
        outline: 0;
        text-decoration: navajowhite;
        background-color: transparent;

        span {
          display: block;
          position: absolute;
          right: 10px;
          top: 0;
          line-height: 40px;
          font-size: var(--font-size-icon-m);
          font-family: var(--font-icons);
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;

          &:before {
            content: "\e915";
          }

          &:hover, &:focus {
            text-decoration: none;
            color: var(--color-red);
          }
        }
      }
    }
  }
}

@include validation-error-styles;

.error {
  background-color: var(--color-transparent);
  color: var(--color-red);
}

.map-wrapper {
  min-height: 360px;
  @include map-wrapper;
}

@include media-max-width($breakpoint-m) {
  .map-wrapper {
    min-height: 300px;

    .map-canvas {
      height: 300px;
    }
  }
}

@include media-max-width($breakpoint-s) {
  .container {
    .search {
      flex-direction: column;
    }
  }
}
